(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-with-tab"] && !Shopify.designMode) return;
  try {
    

const tabs = document.querySelectorAll('.tab_btn')
const sliders = document.querySelectorAll('.collection_slider')

tabs.forEach(btn => {

  btn.addEventListener('click', ()=>{

    const tab = btn.dataset.tab

    tabs.forEach(b=>b.classList.remove('active'))
    btn.classList.add('active')

    sliders.forEach(slider=>{

      if(slider.dataset.tab === tab){
        slider.style.display = 'block'
      }else{
        slider.style.display = 'none'
      }

    })

  })

})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hunting_voucher"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async function(e) {
  const copyBtn = e.target.closest('.btn-copycode');

  if (copyBtn) {
    const item = copyBtn.closest('.hunting_voucher_item');
    const input = item.querySelector('.code input');
    const code = input ? input.value.trim() : '';

    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);

      copyBtn.classList.add('is-copied');

      setTimeout(() => {
        copyBtn.classList.remove('is-copied');
      }, 500);
    } catch (err) {
      console.error('Copy failed:', err);
    }

    return;
  }

  const tncBtn = e.target.closest('.btn-tandc');

  if (tncBtn) {
    const item = tncBtn.closest('.hunting_voucher_item');
    const popup = item.querySelector('.voucher-tnc-popup');

    document.querySelectorAll('.voucher-tnc-popup').forEach(function(el) {
      if (el !== popup) el.hidden = true;
    });

    popup.hidden = !popup.hidden;
    return;
  }

  const closeBtn = e.target.closest('.voucher-tnc-popup__close');

  if (closeBtn) {
    closeBtn.closest('.voucher-tnc-popup').hidden = true;
    return;
  }

  if (!e.target.closest('.voucher-tnc-popup')) {
    document.querySelectorAll('.voucher-tnc-popup').forEach(function(el) {
      el.hidden = true;
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
